export type BrandKey = 'pbf' | 'pcf' | 'default';

export interface IBrandConfig {
  key: BrandKey;
  name: string;
  logo: string;
  favicon: string;
  primaryColor: string;
}

const BRANDS: Record<BrandKey, IBrandConfig> = {
  pbf: {
    key: 'pbf',
    name: 'PBF Membership Management',
    logo: '/images/pbf-logo.png',
    favicon: '/images/pbf-logo.png',
    primaryColor: '#007BFF',
  },
  pcf: {
    key: 'pcf',
    name: 'PCF Membership Management',
    logo: '/images/pcf-logo.png',
    favicon: '/images/pcf-logo.png',
    primaryColor: '#E05C00',
  },
  default: {
    key: 'default',
    name: 'Membership Management',
    logo: '/images/app-logo.png',
    favicon: '/images/pbf-logo.png',
    primaryColor: '#007BFF',
  },
};

// The app's own name — and therefore the fixed prefix of every deployment host on *.shesha.app,
// which are named `pbf-membershipmanagement-adminportal-<tenant>-<env>.shesha.app`.
const APP_HOST_PREFIX = "pbf-membershipmanagement";

/**
 * Resolves a brand from a host string (e.g. `pbf.localhost:3000`). Works on both server and client,
 * so the brand can be detected from the request `Host` header during SSR as well as from
 * `window.location` in the browser.
 */
export function brandFromHost(host: string | null | undefined): IBrandConfig {
  if (!host) return BRANDS.default;
  let h = host.toLowerCase();

  // The app-name prefix contains the token "pbf", which would otherwise shadow the real tenant
  // slug on deployment hosts (e.g. `…-adminportal-pcf-test.shesha.app` would wrongly match "pbf"
  // before "-pcf-" is ever checked). Strip the known prefix so the tenant slug decides the brand.
  if (h.startsWith(APP_HOST_PREFIX)) h = h.slice(APP_HOST_PREFIX.length);

  if (/(^|[.-])pbf([.-]|$)/.test(h)) return BRANDS.pbf;
  if (/(^|[.-])pcf([.-]|$)/.test(h)) return BRANDS.pcf;
  return BRANDS.default;
}

export function detectBrand(): IBrandConfig {
  if (typeof window === 'undefined') return BRANDS.default;
  return BRANDS.default; // Default to the default brand from now
}

export { BRANDS };
